import { Component, OnInit, Injector } from '@angular/core';
import { SecondPageEditBase, UserService } from 'vnpost-shared';
import {
  UntypedFormGroup,
  UntypedFormControl,
  Validators,
} from '@angular/forms';
import { TypeCustomerService } from '../../services/type-customer.service';
import { ServiceProductService } from '../../services/service-product.service';
import { ServiceCommissionsService } from '../../services/service-commissions-.service';
import { CategoryUnitService } from '../../services/category-unit.service';

@Component({
  selector: 'app-add-commissions-for-service',
  templateUrl: './add-commissions-for-service.component.html',
  styleUrls: ['./add-commissions-for-service.component.css']
})
export class AddCommissionsForServiceComponent
  extends SecondPageEditBase
  implements OnInit
  {
  listStatus: { label: string; value: number }[] = [
    { label: 'Đang áp dụng', value: 1 },
    { label: 'Ngừng áp dụng', value: 0 },
  ];
  listServiceProduct: { label: string; value: string }[] = [];
  listCategoryUnit: { label: string; value: string }[] = [];
  listCustomerCategory: { label: string; value: string }[] = [];

  cols: any;

  commissionByCustomerCategories: any[] = [];

  constructor(
    protected _serviceCommissionsService: ServiceCommissionsService,
    protected _serviceProductService: ServiceProductService,
    protected _categoryUnitService: CategoryUnitService,
    protected _typeCustomerService: TypeCustomerService,
    protected _injector: Injector,
  ) {
    super(_serviceCommissionsService, _injector);
    this.formGroup = new UntypedFormGroup({
      serviceProductCode: new UntypedFormControl('', [Validators.required]),
      unitCode: new UntypedFormControl('', [Validators.required]),
      status: new UntypedFormControl('')
    });
    this.cols = [
      { field: 'customerCategoryCode', header: 'Loại khách hàng', visible: true },
      { field: 'commissionRate', header: 'Hoa hồng được hưởng', visible: true },
      { field: 'action', header: 'Hành động', visible: true },
    ];
  }

  ngOnInit() {
  }

  onShowPopup() {
    if (this.listServiceProduct.length == 0) {
      this.getListServiceProduct();
    }
    if (this.listCategoryUnit.length == 0) {
      this.getListCategoryUnit();
    }
    if (this.listCustomerCategory.length == 0) {
      this.getListCustomerCategory();
    }
    this.validationSummary.resetErrorMessages();
    this.resetForm();

    this.onReset();

    this.itemDetail.id = 0;
    this.itemDetail.status = 1;
    this.commissionByCustomerCategories = [{
      customerCategoryCode: '',
      commissionRate: '0',
      action: 'add',
      id: 0
    }];
  }

  getListServiceProduct() {
    this._serviceProductService.getListServiceProduct({status: 1}).then(res => {
      this.listServiceProduct = res?.data.map(x => ({label: `${x.serviceProductName} (${x.serviceProductCode})`, value: x.serviceProductCode}));
    },err => {
      this.listServiceProduct = []
    })
  }

  getListCategoryUnit() {
    this._categoryUnitService.getCategoryUnit({status: 1}).then(res => {
      this.listCategoryUnit = res?.data.map(x => ({label: `${x.unitName} (${x.unitCode})`, value: x.unitCode}));
    },err => {
      this.listCategoryUnit = []
    })
  }

  getListCustomerCategory() {
    this._typeCustomerService.getListTypeCustomer({status: 1}).then(res => {
      this.listCustomerCategory = res?.data.map(x => ({label: `${x.customerName} (${x.customerCode})`, value: x.customerCode}));
    },err => {
      this.listCustomerCategory = []
    })
  }

  onAddCommissionByCustomer(index: any) {
    this.commissionByCustomerCategories[index].action = 'delete';
    this.commissionByCustomerCategories.push({
      customerCategoryCode: '',
      commissionRate: '0',
      action: 'add',
      id: 0
    })
  }

  onDeleteCommissionByCustomer(index: any) {
    this.commissionByCustomerCategories.splice(index, 1);
  }


  async save() {
    this.submitting = true;

    if (this.formGroup.invalid) {
      this.submitting = false;
      this.validationSummary.showValidationSummary();
      return;
    }

    var commissionByCustomerCategoriesSave = this.commissionByCustomerCategories.filter(x => x.customerCategoryCode && x.customerCategoryCode.trim());

    var duplicateCustomerIndex = this.commissionByCustomerCategories.findIndex((x, index, cus) => cus.filter(c => c.customerCategoryCode === x.customerCategoryCode).length > 1);
    if (duplicateCustomerIndex > -1) {
      this.submitting = false;
      this._notifierService.showError(`Loại khách hàng dòng ${duplicateCustomerIndex + 1} đã tồn tại`);
      return;
    }

    var emptyRateIndex = commissionByCustomerCategoriesSave.findIndex(x => !x.commissionRate || x.commissionRate == 0);
    if (emptyRateIndex > -1) {
      this.submitting = false;
      this._notifierService.showError(`Hoa hồng dòng ${emptyRateIndex + 1} không được để trống`);
      return;
    }
    var invalidRateIndex = commissionByCustomerCategoriesSave.findIndex(x => !(/^100(\.00?)?$|^\d{1,2}(\.\d{1,2})?$/).test(x.commissionRate));
    if (invalidRateIndex > -1) {
      this.submitting = false;
      this._notifierService.showError(`Hoa hồng dòng ${invalidRateIndex + 1} không hợp lệ`);
      return;
    }
    this.itemDetail.commissionByCustomerCategories = this.commissionByCustomerCategories.filter(x => x.customerCategoryCode && x.customerCategoryCode.trim());
    this.onInsert();
  }
  onInsert() {
    this._serviceCommissionsService.create(this.itemDetail).then(
      (response) => {
        this.closePopupMethod(true);
        this._notifierService.showInsertDataSuccess();
        this.onAfterSave();
        this.submitting = false;
      },
      (error) => {
        this._notifierService.showInsertDataFailed();
        this.submitting = false;
      }
    );
  }
}
